import type { FC } from "react";
import React from "react";
import type { NestedNavRouteMenu } from "@/routerConfig";
import ArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ListItemButton from "@mui/material/ListItemButton";
import { styled } from "@mui/material/styles";
import classNames from "classnames";
import NavBtnContent from "./NavBtnContent";
import css from "./NavMenu.module.css";
import NavMenuItem from "./NavMenuItem";

type NavSectionProps = {
  setOpenItem: (id: string) => void;
  item: NestedNavRouteMenu;
  /** the label of the currently open section */
  openItem?: string;
  /** contains the active page route */
  isActive?: boolean;
};

const SectionArrow = styled(ArrowDownIcon)(`
  transition: all 150ms ease-in-out;
  color: var(--brand-storm-300);
  &.open {
    transform: rotateZ(180deg);
    color: white;
  }
`);

const NavSection: FC<NavSectionProps> = ({
  setOpenItem,
  item,
  openItem,
  isActive,
}) => {
  const { label, icon, children } = item;
  const open = openItem === label;
  return (
    <>
      <ListItemButton
        className={classNames(css.itemButton, {
          [css.open]: open,
          [css.activeSection]: isActive,
        })}
        onClick={() => {
          setOpenItem(open ? "" : label);
        }}
      >
        <NavBtnContent icon={icon}>{label}</NavBtnContent>
        <SectionArrow className={classNames({ open })} />
      </ListItemButton>
      <ul
        aria-hidden={!open}
        className={classNames(css.expandingList, { [css.open]: open })}
      >
        {children?.map(({ path, label: childLabel, ...restProps }) => (
          <NavMenuItem
            key={path}
            path={path}
            {...restProps}
            parentLabel={label}
          >
            {childLabel}
          </NavMenuItem>
        ))}
      </ul>
    </>
  );
};

export default NavSection;
